import { z } from 'zod';

export const ourDreamSchema = z.object({
  eyebrow: z.string().min(1),
  title: z.string().min(1),
  body: z.string().min(1),
});

export type OurDream = z.infer<typeof ourDreamSchema>;
